import type { RefObject } from 'react';
import { IconButton } from '@mui/material';
import {
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
} from '@mui/icons-material';
import { useElementFullscreen } from '../hooks';

const mapFullscreenToggleButtonSx = {
  position: 'absolute',
  right: 12,
  top: 12,
  zIndex: 1100,
  boxSizing: 'border-box',
  width: 52,
  height: 52,
  padding: 0,
  border: '1px solid var(--secondary-color)',
  borderRadius: 1,
  backgroundColor: 'var(--white-color)',
  color: 'var(--secondary-color)',
  boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
  '&:hover': {
    backgroundColor: 'var(--light-gray)',
  },
} as const;

const mapFullscreenToggleIconSx = {
  fontSize: 28,
} as const;

interface MapFullscreenToggleButtonProps {
  targetRef: RefObject<HTMLElement | null>;
  onError?: (message: string) => void;
}

const MapFullscreenToggleButton = ({
  targetRef,
  onError,
}: MapFullscreenToggleButtonProps) => {
  const { isFullscreen, toggleFullscreen } = useElementFullscreen({
    targetRef,
    onError,
  });

  const handleToggleFullscreen = () => {
    void toggleFullscreen();
  };

  return (
    <IconButton
      type='button'
      onClick={handleToggleFullscreen}
      aria-pressed={isFullscreen}
      aria-label={
        isFullscreen
          ? 'Salir de pantalla completa'
          : 'Ver mapa en pantalla completa'
      }
      sx={mapFullscreenToggleButtonSx}
    >
      {isFullscreen ? (
        <FullscreenExitIcon sx={mapFullscreenToggleIconSx} />
      ) : (
        <FullscreenIcon sx={mapFullscreenToggleIconSx} />
      )}
    </IconButton>
  );
};

export default MapFullscreenToggleButton;
